export const GET_CARRIER = "/api/Carrier/GetCarrier";
export const SAVE_CARRIER = "/api/Carrier/SaveCarrier";
export const DELETE_CARRIER = "/api/Carrier/DeleteCarrierData?CarrierID=";
export const SAVE_USER_REGION_REQUEST =
"/api/Regions/SaveUserRegionRequestData";
export const INSERT_REGION_APPROVAL =
"/api/Regions/InsertUserRegionsApprovalData";
export const GET_USER_REGION_REQUEST =
"/api/Regions/GetUserRegionsRequestData?UD_Id=";
export const GET_ALL_USER_DETAILS = "/api/UserDetail/GetUserDetailDataForAdmin";
export const UPDATE_USER_DETAILS = "/api/UserDetail/UpdateUserDetailIsActive?";
export const UPDATE_USER_ROLE = "/api/UserDetail/UpdateUserRole?";
export const GET_AGE_BAND = "/api/ACG_AgeBand/GetAgeBand";
export const GET_AGE_BAND_DETAILS = "/api/ACG_AgeBand/GetAgeBandDetails/";
export const ADD_AGE_BAND = "/api/ACG_AgeBand/AddAgeBand";
export const DELETE_AGE_BAND = "/api/ACG_AgeBand/DeleteAgeBand/";
export const GET_AGE_SEX_RISK = "/api/ACG_AgeSexRisk/GetAgeSexRisk";
export const GET_AGE_SEX_RISK_DETAILS =
  "/api/ACG_AgeSexRisk/GetAgeSexRiskDetails/";
export const ADD_AGE_SEX_RISK = "/api/ACG_AgeSexRisk/AddAgeSexRisk";
export const UPDATE_AGE_SEX_RISK = "/api/ACG_AgeSexRisk/UpdateAgeSexRisk";
export const DELETE_AGE_SEX_RISK = "/api/ACG_AgeSexRisk/DeleteAgeSexRisk/";
export const GET_CBSA = "/api/ACG_CBSA/GetCBSA";
export const ADD_UPDATE_CBSA = "/api/ACG_CBSA/AddUpdateCBSA";
export const DELETE_CBSA = "/api/ACG_CBSA/DeleteCBSA?ID=";
export const GET_CMSA_SIZEP_DETAILS = "/api/ACGCmsaSizeP/GetCmsasizepDetails";
export const ADD_CMSA_SIZEP = "/api/ACGCmsaSizeP/AddCmsasizep";
export const UPDATE_CMSA_SIZEP = "/api/ACGCmsaSizeP/UpdateCmsasizep/";
export const DELETE_CMSA_SIZEP = "/api/ACGCmsaSizeP/DeleteCmsasizep/";
export const GET_COCI_DETAILS = "/api/ACGCoci/GetCociDetails";
export const GET_COCI = "/api/ACGCoci/GetCoci";
export const ADD_COCI = "/api/ACGCoci/AddCoci";
export const DELETE_COCI = "/api/ACGCoci/DeleteCoci?cociId=";
export const UPDATE_COCI = "/api/ACGCoci/UpdateCoci?cociId=";

export const GET_DRF_DETAILS = "/api/DRF/GetDrfDetails";
export const ADD_DRF = "/api/ACGDRF/AddDrf";
export const UPDATE_DRF = "/api/ACGDRF/UpdateDrf?drfId=";
export const DELETE_DRF = "/api/ACGDRF/DeleteDrf?drfId=";

export const GET_MEDC_DETAILS = "/api/ACGMedcInflation/GetMedcDetails";
export const GET_MEDC_DETAILS_BY_ID =
"/api/ACGMedcInflation/GetMedcDetailsByID";
export const ADD_MEDC = "/api/ACGMedcInflation/AddMedcInfl";
export const UPDATE_MEDC = "/api/ACGMedcInflation/UpdateMedcInfl?medcinflId=";
export const DELETE_MEDC = "/api/ACGMedcInflation/DeleteMedcInfl?medcInflId=";

export const GET_MEDC_GEND_DETAILS = "/api/ACGMedcGend/GetMedcGendDetails";
export const ADD_MEDC_GEND = "/api/ACGMedcGend/AddMedcGend";
export const UPDATE_MEDC_GEND = "/api/ACGMedcGend/UpdateMedcGend?medcGendId=";
export const DELETE_MEDC_GEND = "/api/ACGMedcGend/DeleteMedcGend?medcGendId=";

export const GET_LSRAF_DETAILS = "/api/ACGLsraf/GetLsrafDetails";
export const ADD_LSRAF = "/api/ACGLsraf/AddLsraf";
export const UPDATE_LSRAF = "/api/ACGLsraf/UpdateLsraf?LsrafId=";
export const DELETE_LSRAF = "/api/ACGLsraf/DeleteLsraf?LsrafId=";

export const GET_GEO_DETAILS = "/api/ACGGeog/GetGeogDetails";
export const GET_GEO_DETAILS_PAGGING = "/api/ACGGeog/GetGeogDetails_Paging?";
export const GET_GEO_DETAILS_PAGGING_SEARCH =
"/api/ACGGeog/GetGeogDetails_PagingSearch?";
export const ADD_GEO = "/api/ACGGeog/AddGeog";
export const UPDATE_GEO = "/api/ACGGeog/UpdateGeog?geogId=";
export const DELETE_GEO = "/api/ACGGeog/DeleteGeog?geogId=";
export const IMPORT_GEO = "/api/ACGGeog/ImportGEO";

export const GET_INDR_DETAILS = "/api/ACGIndrRisk/GetIndrDetails";
export const ADD_INDR = "/api/ACGIndrRisk/AddIndr";
export const UPDATE_INDR = "/api/ACGIndrRisk/UpdateIndr?indrId=";
export const DELETE_INDR = "/api/ACGIndrRisk/DeleteIndr?indrId=";

export const GET_INSUR_DETAILS = "/api/ACGInsur/GetInsurDetails";
export const ADD_INSUR = "/api/ACGInsur/AddInsur";
export const UPDATE_INSUR = "/api/ACGInsur/UpdateInsur?insurId=";
export const DELETE_INSUR = "/api/ACGInsur/DeleteInsur?insurId=";

export const GET_FUNDING_DETAILS = "/api/ACGFunding/GetFundingDetails";
export const ADD_FUNDING = "/api/ACGFunding/AddFunding";
export const UPDATE_FUNDING = "/api/ACGFunding/UpdateFunding/";
export const DELETE_FUNDING = "/api/ACGFunding/DeleteFunding/";

export const GET_PLANVAR_DETAILS = "/api/ACGPlanVar/GetPlanVarDetails";
export const GET_PLANVAR_DETAILS_BY_ID = "/api/ACGPlanVar/GetPlanVar/";
export const ADD_PLANVAR = "/api/ACGPlanVar/AddPlanVar";
export const UPDATE_PLANVAR = "/api/ACGPlanVar/UpdatePlan/";
export const DELETE_PLANVAR = "/api/ACGPlanVar/DeletePlanVar/";

export const GET_TIER_DETAILS = "/api/ACGTier/GetTierDetails";
export const ADD_TIER = "/api/ACGTier/AddTier";
export const UPDATE_TIER = "/api/ACGTier/UpdateTier/";
export const DELETE_TIER = "/api/ACGTier/DeleteTier/";

export const GET_UWellnessProgram_DETAILS =
  "/api/ACG_UWellness_Program/GetUWellnessProgramDetails";
export const GET_UWellnessProgram_DETAILS_BY_ID =
  "/api/ACG_UWellness_Program/GetUWellnessProgramById/";
export const ADD_UWellnessProgram = "/api/ACG_UWellness_Program/AddWellness";
export const DELETE_UWellnessProgram =
"/api/ACG_UWellness_Program/DeleteUWellnessProgram/";

export const GET_LARGE_CLAIM_DETAILS =
"/api/ACGLargeClaim/GetLargeClaimDetails";
export const GET_LARGE_CLAIM_DETAILS_BY_ID =
"/api/ACGLargeClaim/GetLargeClaimDetail/";
export const ADD_LARGE_CLAIM = "/api/ACGLargeClaim/AddLargeClaim";
export const UPDATE_LARGE_CLAIM = "/api/ACGLargeClaim/UpdateLargeClaim/";
export const DELETE_LARGE_CLAIM = "/api/ACGLargeClaim/DeleteLargeClaim/";

export const GET_UWMATERNITY_DETAILS =
"/api/ACGUWMaternity/GetMaternityDetails";
export const GET_UWMATERNITY_DETAILS_BY_ID =
"/api/ACGUWMaternity/GetMaternityDetail/";
export const ADD_UWMATERNITY = "/api/ACGUWMaternity/AddMaternity";
export const UPDATE_UWMATERNITY = "/api/ACGUWMaternity/UpdateMaternity/";
export const DELETE_UWMATERNITY = "/api/ACGUWMaternity/DeleteMaternityDetail/";

export const GET_RUBs_DETAILS = "/api/api/Rub/ACGRub/GetRubDetails";
export const GET_RUBs_DETAILS_BY_ID = "/api/api/Rub/ACGRub/GetRubDetail/";
export const ADD_RUBs = "/api/api/Rub/ACGRub/AddRub";
export const UPDATE_RUBs = "/api/api/Rub/ACGRub/UpdateRub/";
export const DELETE_RUBs = "/api/api/Rub/ACGRub/DeleteRub/";
export const GET_COMPANY_SIZE = "/api/CompanyDetail/GetCompanySize";
export const GET_LOCATION_CLIENT = "/api/CompanyDetail/GetLocationforClient";
export const SAVE_COMPANY_SETUP_DETAILS =
"/api/CompanyDetail/SaveCompanySetUpDetail";
export const SAVE_CLIENT_VISION_PLAN_DETAILS =
"/api/VisionPlanSetup/SaveClientsVisionPlanDetails";
export const GET_CLIENT_VISION_PLAN_DETAILS =
"/api/VisionPlanSetup/GetClientsVisionPlanDetails?";
export const SAVE_CLIENT_REBATES_REIMBURSEMENT_DETAILS =
"/api/ClientsRebatesAndReimbursements/SaveClientsRebatesAndReimbursementsDetail";
export const GET_CLIENT_REBATES_REIMBURSEMENT_DETAILS =
  "/api/ClientsRebatesAndReimbursements/GetClientsRebatesAndReimbursementsDetails?";
export const DETELE_CLIENT_REBATES_REIMBURSEMENT_DETAILS =
"/api/ClientsRebatesAndReimbursements/DeleteClientsRebatesAndReimbursementsDetails?RebatesID=";
export const GET_FILE_TYPE = "/api/FileType/GetFileTypeData";
export const GET_MEDICAL_CARRIER_DATA =
"/api/MedicalCarrier/GetMedicalCarrierData?";
export const SAVE_MEDICAL_CARRIER_DATA =
"/api/MedicalCarrier/SaveMedicalCarrierData";
export const UPDATE_MEDICAL_CARRIER_DATA =
"/api/MedicalCarrier/UpdateMedicalCarrierData";
export const DELETE_MEDICAL_CARRIER_DATA =
"/api/MedicalCarrier/DeleteMedicalCarrierData?MedCarID=";
export const SAVE_CLIENT_DENTAL_PLAN_DETAILS =
  "/api/DentalPlanSetup/SaveClientsDentalPlanDetails";
export const GET_CLIENT_DENTAL_PLAN_DETAILS =
"/api/DentalPlanSetup/GetClientsDentalPlanDetails?";
export const GET_MEDICAL_PLAN_FUNDING_TYPE =
"/api/MedicalPlanSetup/GetClientsMedicalPlanFundingType";
export const GET_CLIENT_MEDICAL_PLAN_STOP_LOSS =
"/api/MedicalPlanSetup/GetClientsMedicalPlanStopLossInsurer";
export const GET_CLIENT_MEDICAL_PLAN_TYPE =
"/api/MedicalPlanSetup/GetClientsMedicalPlanType";
export const GET_CLIENT_MEDICAL_PLAN_DETAILS =
"/api/MedicalPlanSetup/GetClientsMedicalPlanDetails?";
export const SAVE_CLIENT_MEDICAL_PLAN_DETAILS =
  "/api/MedicalPlanSetup/SaveClientsMedicalPlanDetails";
export const GET_USER_DETAIL =
  "/api/UserDetail/GetUserDetailData?UD_emp_email=";
export const UPDATE_USER_DETAILS_HIDE = "/api/UserDetail/UpdateUserDetailHide?";
export const GET_DEPARTMENT_DATA = "/api/Department/GetDepartmentData";
export const SAVE_USER_DETAILS = "/api/UserDetail/SaveUserDetailData";

export const GET_WELLNESS_DETAILS = "/api/ACGWellnessRate/GetWellnessDetails";
export const GET_WELLNESS_DETAILS_BY_ID =
"/api/ACGWellnessRate/GetWellnessDetail/";
export const ADD_WELLNESS = "/api/ACGWellnessRate/AddWellness";
export const UPDATE_WELLNESS = "/api/ACGWellnessRate/UpdateWellness/";
export const DELETE_WELLNESS = "/api/ACGWellnessRate/DeleteWellness/";

export const GET_TOP_CONDITION_DETAILS =
"/api/ACGTopCondition/GetTopconditionDetails";
export const GET_TOP_CONDITION_DETAILS_BY_ID =
"/api/ACGTopCondition/GetTopcondition/";
export const ADD_TOP_CONDITION = "/api/ACGTopCondition/AddTopcondition";
export const UPDATE_TOP_CONDITION = "/api/ACGTopCondition/UpdateTopcondition/";
export const DELETE_TOP_CONDITION = "/api/ACGTopCondition/DeleteTopcondition/";

export const GET_ERU_DETAILS = "/api/ACG_ERU/GetEruDetails";
export const GET_ERU_BY_ICDCODES = "/api/ACG_ERU/EruByICDCodes/";
export const ADD_OR_UPDATE_ERU = "/api/ACG_ERU/SaveData";
export const IMPORT_ERU = "/api/ACG_ERU/ImportEru";

export const GET_UWMARGIN_DETAILS = "/api/ACG_UWMargin/GetUWMarginDetails";
export const GET_UWMARGIN_DETAILS_BY_ID =
"/api/ACG_UWMargin/GetUWMarginDetail/";
export const ADD_UWMARGIN = "/api/ACG_UWMargin/AddUWMargin";
export const UPDATE_UWMARGIN = "/api/ACG_UWMargin/UpdateUWMargin/";
export const DELETE_UWMARGIN = "/api/ACG_UWMargin/DeleteUWMargin/";

export const GET_STATE = "/api/ACG_AllRankedMeasure/GetState";
export const GET_ALL_RANKED_MEASURE_DATA =
"/api/ACG_AllRankedMeasure/GetAllRankedMeasureData?stateid=";
export const GET_RANKED_MEASURE_DATA_BY_ID =
"/api/ACG_AllRankedMeasure/GetRankedMeasureDataDetail/";
export const ADD_RANKED_MEASURE =
"/api/ACG_AllRankedMeasure/AddRankedMeasureData";
export const DELETE_RANKED_MEASURE =
"/api/ACG_AllRankedMeasure/DeleteRankedMeasureData/";

export const GET_INVALID_ICD10ZIP_DETAILS =
"/api/ACG_InvalidICD/GetLargeCliamInvalidICD10ZipDetails";
export const DELETE_ALL_INVALID_ICDZIPCODE =
"/api/ACG_InvalidICDZipcode/DeleteAllInvalidICDZipcode";

export const GET_IMPORT_HISTORY = "/api/ACG_ImpoerHistory/GetImportHistory";
export const DELETE_IMPORT_HISTORY = "/api/ACG_ImpoerHistory/DeleteHistory/";

export const GET_SALARY_RISK_DETAILS = "/api/ACG_SalaryRisk/GetSalaryRisk";
export const GET_SALARY_RISK_DETAILS_BY_ID =
"/api/ACG_SalaryRisk/GetSalaryRiskDetails/";
export const ADD_SALARY_RISK = "/api/ACG_SalaryRisk/AddSalaryRisk";
export const UPDATE_SALARY_RISK = "/api/ACG_SalaryRisk/UpdateSalaryRisk";
export const DELETE_SALARY_RISK = "/api/ACG_SalaryRisk/DeleteSalaryRisk/";

export const ADD_GDOR_MASTER_DETAIL =
  "/api/ACG_GDORMasterDetail/AddGDORMasterDetail";
export const UPDATE_GDOR_MASTER_DETAIL =
  "/api/ACG_GDORMasterDetail/UpdateGDORMasterDetail";
  export const DELETE_GDOR_MASTER_DETAIL =
  "/api/ACG_GDORMasterDetail/DeleteGDORMasterDetail/";
  
  export const GET_CLIENT_LARGE_CLAIM_BY_CLIENT_NAME =
  "/api/ACG_ClientLargeClaim/GetClientLargeClaimyClientName/";
  export const IMPORT_LARGE_CLAIM =
  "/api/ACG_ClientLargeClaim/ImportLargeClaimPepm?ClientId=";
  export const ADD_CLIENT_LARGE_CLAIM =
  "/api/ACG_ClientLargeClaim/AddDataToLargeClaim?licenseName=";
export const ADD_DATA_TO_EMPOWER_RX_SPECIALTY_DRUG =
  "/api/EmpoweRxSpecialtyDrugList/AddDataToEmpoweRxSpecialtyDrug?";
export const IMPORT_EMPOWER_RX_SPECIALTY_DRUG=
  "/api/EmpoweRxSpecialtyDrugList/ImportEmpoweRxSpecialtyDrug?";
export const CREATEORUPDATERXBLOCKPRICING=
  "/api/RxBlockPricing/CreateOrUpdateRxBlockPricing";

export const GET_WELLNESS_PROGRAM_BY_CLIENT_NAME =
  "/api/ACG_ClientWellnessProgram/WellnessProgramByClientName/";
export const GET_BENCHMARK = "/api/ACG_ClientWellnessProgram/GetBenchmark";
export const UPDATE_CLIENT_WELLNESS_PROGRAM =
  "/api/ACG_ClientWellnessProgram/UpdateData";

export const GET_COBRA_BY_CLIENT_NAME =
  "/api/ACG_ClientCobra/GetCobraByClientName/";
  export const UPDATE_COBRA = "/api/ACG_ClientCobra/UpdateData";
  
  export const GET_LARGE_CLAIM_UW_PEMP_BY_CLIENT_NAME =
  "/api/ACG_ClientLargeClaimUWPEPM/GetClientLargeClaimUWPEPMByClientName/";
  export const UPDATE_LARGE_CLAIM_UW_PEMP =
  "/api/ACG_ClientLargeClaimUWPEPM/UpdateData";
  
  export const UPDATE_LARGE_CLAIM_UW_PEMP_CLIENT =
  "/api/ACG_ClientLargeClaimUWPEPM/UpdateLargeClaimPepm/";

export const DOWNLOAD_ERROR_FILE =
  "/api/ACG_Census/DownloadCensusErrorFile?filename=";
  export const IMPORT_CENSUS = "/api/ACG_Census/ImportCensus?ClientName=";
  
  export const GET_PALN_AV_DEVIATION_BY_CLIENT_NAME =
  "/api/ACG_PlanAV&Deviation/GetPlanAvDeviationByClientName/";
  export const UPDATE_PALN_AV_DEVIATION =
  "/api/ACG_PlanAV&Deviation/UpdatePlanAvDeviation";
  export const CALCULATE_PALN_AV_DEVIATION =
  "/api/ACG_PlanAV&DeviationCalculation/CalculateDeviation/";
  export const CHECK_CLIENT_IN_CENSUS_DETAIL =
  "/api/ACG_PlanAV&DeviationCalculation/CheckClientInCensusDetails/";
  export const CHECK_CLIENT_IN_CENSUS_BY_CLIENT =
  "/api/ACG_UpdateCensus/CheckClientInCensusByClientId/";
  export const UPDATE_CENSUS = "/api/ACG_UpdateCensus/UpdateCensus?clientId=";
  export const UPDATE_CENSUS_STAGE2 =
  "/api/ACG_UpdateCensus/UpdateCensusStage2?clientId=";
  export const UPDATE_CENSUS_STAGE3 =
  "/api/ACG_UpdateCensus/UpdateCensusStage3?clientId=";
  export const UPDATE_CENSUS_STAGE4 =
  "/api/ACG_UpdateCensus/UpdateCensusStage4?clientId=";
export const UPDATE_CENSUS_STAGE5 =
  "/api/ACG_UpdateCensus/UpdateCensusStage5?clientId=";
export const UPDATE_CENSUS_STAGE6 =
  "/api/ACG_UpdateCensus/UpdateCensusStage6?clientId=";
  
  export const GET_RUBS_BY_CLIENT_NAME =
  "/api/ACG_ClientsRUBs/GetRubsByClientName/";
  
  export const GET_RENEWAL_ADJUSTMENT_BY_CLIENT_ID =
  "/api/ACG_RenewalAdjustment/GetRenewalAdjustmentByClientId/";
export const UPDATE_ADJUSTMENT = "/api/ACG_RenewalAdjustment/UpdateAdjustment";

export const GET_UNDERWRITING_ADJUSTMENT_BY_CLIENT_ID =
  "/api/ACG_UnderWritingAdjustment/GetUnderwritingAdjustmentByClientId/";
  export const UPDATE_UNDERWRITING_ADJUSTMENT =
  "/api/ACG_UnderWritingAdjustment/UpdateAdjustment";
  
  export const GET_RENEWAL_COMPARISON_BY_CLIENT_ID =
  "/api/FinalACGRateReview/GetRenewalComparisonByClientId?clientId=";
  export const GET_EXPERIENCE_COMPARISON_BY_CLIENT_ID =
  "/api/FinalACGRateReview/GetExperienceComparisonByClientId?clientId=";
  export const GET_ASO_COMPARISON_BY_CLIENT_ID =
  "/api/FinalACGRateReview/GetAsoComparisonByClientId?clientId=";
  export const GET_RATE_REVIEW_REPORT =
  "/api/FinalACGRateReview/GetRateReviewReports?";
  export const GET_ERUS_PAGINATION = "/api/ACG_ERU/GetErusAsyncwithPagging?";
  export const GET_ERUS_PAGINATION_SEARCH =
  "/api/ACG_ERU/GetErusAsyncwithPagingSearch?";
  
  export const CHECK_REPORTS_DATA = "/api/ACG_ExportReports/CheckReportsData?";
  export const CHECK_REPORT_DATA_FOR_SDOH =
  "/api/ACG_ExportReports/checkReportDataForSDOH?clientId=";
  
  export const GET_COMMISSIONRATEBYGROUPSIZEZIPCODE =
  "/api/ACG_ClientDetails/GetCommissionRateByGroupSizeZipCode?";
  export const SAVE_CLIENT_DETAILS = "/api/ACG_ClientDetails/SaveData";
  export const UPDATE_CLIENT_DETAILS = "/api/CompanyDetail/UpdateClientsDetails";
  export const GET_INDUSTRY_DATA_FOR_COMPANY_SETUP = "/api/Industry/GetIndustry";
  export const IMPORTDATAINTOSNOWFLAKE =
  "/api/ACG_ExportReports/ImportDataintoSnowflake?";
  export const IMPORTDATAINTOSNOWFLAKEWITHTRACKING =
  "/api/ACG_ExportReports/ImportDataintoSnowflakewithTracking?";
  export const CHECKDATAINSERTINTOSNOWFLAKE =
  "/api/ACG_ExportReports/CheckDatainsertintoSnowflake?";
  export const GET_ALL_FILETYPE_CARRIER =
  "/api/FileReadWrite/GetAllFileTypeByCarrier";
  export const GET_FILETYPE_DATA = "/api/FileType/GetFileTypeData";
export const SAVE_UPDATE_FILETYPE =
"/api/FileReadWrite/SaveUpdateFileTypeByCarrier";
export const DELETE_FILETYPE = "/api/FileReadWrite/DeleteFileTypeByCarrier?ID=";
export const GET_REGIONS_DATA = "/api/Regions/GetRegionsData";
export const GET_CLIENT_DATA_BY_UDID =
"/api/Clients/GetClientsDataByUDid?UD_id=";
export const GET_USER_NOTIFICATION =
"/api/Notification/GetUserNotificationData?";
export const GET_FILETYPE_CARRIER =
"/api/FileReadWrite/GetFileTypeByCarrier?CarrierID=";
export const GET_CATEGORY_MASTER = "/api/FileReadWrite/GetCategoryMaster";
export const GET_FILE_TYPE_DATA = "/api/FileType/GetFileTypeData";
export const SAVE_NOTIFICATION_CLEAR_DATA =
  "/api/Notification/SaveNotificationClearData";
  export const SIGNIN_API_URL =
  "/api/account/external-login?provider=Microsoft&returnUrl=Welcome";
  export const VERIFY_API_URL = "/api/verify-mfa?code=";
  export const SIGNOUT_API_URL = "/api/signout-microsoft-hub";
  export const GET_CLIENT_DATA_BY_UDID_BY_PAGE =
  "/api/Clients/GetClientsData_UDid_Paging?";
  export const GET_ALL_EMPOWER_RX_DRUG_DISCOUNT =
  "/api/EmpoweRxDrugDiscount/GetAllEmpoweRxDrugDiscountWithPagination?";
  export const GET_PBM =
  "/api/EmpoweRxSpecialtyDrugList/GetPBMList";
  export const GET_CLIENT_DATA_BY_UDID_BY_PAGE_BY_SEARCH =
  "/api/Clients/GetClientsData_UDid_Paging_Search?";
  export const GET_FEE_BY_FUNDING_ARRANGEMENT =
  "/api/MedicalPlanSetup/GetFeeByFundingArrangement?";
  export const GET_SUB_FEE_BY_MAIN_FEE =
  "/api/MedicalPlanSetup/GetSubFeeByMainFee?";
  export const GET_FEE_TYPE = "/api/MedicalPlanSetup/GetFeeType";
  export const GET_CLIENT_MEDICAL_PLAN_DETAILS_BY_ID =
  "/api/MedicalPlanSetup/GetClientsMedicalPlanDetailsByID?";
  export const GET_CLIENT_DENTAL_PLAN_DETAILS_BY_ID =
  "/api/DentalPlanSetup/GetClientsDentalPlanDetailsByID?";
  export const GET_CLIENT_VISION_PLAN_DETAILS_BY_ID =
  "/api/VisionPlanSetup/GetClientsVisionPlanDetailsByID?";
  export const GET_APPROVED_REGION_UDID =
  "/api/Regions/GetApprovedRegionsByUDid?";
  export const INSERT_CLINICAL_INTAKE_DATA =
  "/api/ClinicalIntake/InsertClinicalIntakeData";
  export const GET_ICD10NDC_CODE_AND_DESCRIPTION =
  "/api/ClinicalIntake/GetICD10NCDcode_description?";
export const SEND_CLINICAL_FORM_FILL_UP_REQUEST =
"/api/ClinicalIntake/ClinicalFormFillupRequest?";
export const SBAR_INTAKE_REQUEST =
"/api/ClinicalIntake/CreateSBARRequest";
export const GET_CLINICAL_FORM_FILL_UP_REQUEST_LIST =
"/api/ClinicalIntake/GetClinicalFormFillupRequestList";
export const GET_SBAR_INTAK_REQUEST_LIST_WITH_PAGINATION =
"/api/ClinicalIntake/GetSBARRequestListWithPagination?";
export const APPROVE_CLINICAL_FORM_FILL_UP_REQUEST =
"/api/ClinicalIntake/ApproveClinicalFormFillupRequest?";
export const GET_CGT_MEMBER_ID = "/api/ClinicalIntake/GetCGTMemberID?";
export const GET_CGT_MEMBER_IDS = "/api/ClinicalIntake/GetCGTMemberIDs?";
export const GET_CGT_MEMBER_ID_FORM = "/api/ClinicalIntake/GetCGTMembers?CGT_MeMBER_ID";
export const GET_STATES = "/api/ClinicalIntake/GetStates";

export const CREATE_CLIENT = "/api/ACG_ClientDetails/CreateUpdateClient";
export const ACCEPT_TERM_CONDITION =
"/api/ACG_ClientDetails/AcceptTermCondition?";
export const GET_CLIENT_DETAIL_DATA =
"/api/ACG_ClientDetails/GetClientDetailData?";
export const GET_LIST_OF_CLIENT_DETAIL =
"/api/ACG_ClientDetails/GetListOfClientDetail";
export const GENERATE_SISENSE_TOKEN = "/api/generate-sisense-token?";

export const RFP_OPERATION_CREATE = "/api/RFPOperation/Create";
export const RFP_OPERATION_UPDATE = "/api/RFPOperation/Update";
export const RFP_OPERATION_DELETE = "/api/RFPOperation/DeleteRFPDetail?Id=";
export const DRUG_EMPOER_RX_OPERATION_CREATEUPDATE = "/api/EmpoweRxDrugDiscount/CreateOrUpdateEmpoweRxDrugDiscount";
export const DRUG_EMPOER_RX_OPERATION_DELETE = "/api/EmpoweRxDrugDiscount/DeleteEmpoweRxDrugDiscount?empoweRxDrugDiscountId=";
export const GETRFPDETAIL = "/api/RFPOperation/GetRFPDetail?Id=";
export const GETEMPOERDETAIL = "/api/EmpoweRxDrugDiscount/GetEmpoweRxDrugDiscountById?empoweRxDrugDiscountId=";
export const GETLISTOFRFPDETAIL = "/api/RFPOperation/GetListOfRFPDetail";
export const GET_LIST_OF_EMPOWER_RFP = "/api/Empowerx_Rfp/GetListofEmpowerxRfp?";
export const GET_LIST_BIDDER_INFO = "/api/Bidder_Info/GetListBidderInfo?";
export const RFPOPERATIONSERVICEREQUEST =
"/api/RFPOperation/ServiceRequest?emailId=";
export const RFPOPERATIONAPPROVEREJECTSERVICEREQUEST =
  "/api/RFPOperation/ApproveRejectServiceRequest?";
export const GET_EMPOWER_RX_BID_FILE_RECORD =
  "/api/Empowerx_Rfp/GetEmpowerxBidFileRecord?";
export const GETLISTOFRFPSERVICEREQUEST =
"/api/RFPOperation/GetListOfRFPServiceRequest";
export const GETSERVICEREQUESTBYUSERID =
"/api/RFPOperation/GetServiceRequestByUserId?emailId=";
export const GETRFPDETAILBYUSER =
"/api/RFPOperation/GetRFPDetailByUser?usermailid=";

export const SAVECEDARGATEFORMDATA = "/api/CedarGate/SaveCedarGateFormData";
export const UPDATECEDARGATEFORMDATA = "/api/CedarGate/UpdateCedarGateFormData";
export const DELETECEDARGATEFORMDATA = "/api/CedarGate/DeleteCedarGeteForm?CedarGateFormID=";
export const GETCEDARGETEFORM = "/api/CedarGate/GetCedarGeteForm";
export const DOWNLOADCEDARGETEFORM = "/api/CedarGate/DownloadCedarGeteForm?CedarGateFormID=";
export const GETDENTALFUNDING = "/api/api/MasterData/CedarGate/GetDentalFunding";
export const GETANALYTICSFUNDING = "/api/api/MasterData/CedarGate/GetAnalyticsFunding";
export const GETMEDICALFUNDING = "/api/api/MasterData/CedarGate/GetMedicalfunding";
export const GET_EMPOWERX_SPECIALTY_DRUG_LIST  = "/api/EmpoweRxSpecialtyDrugList/GetEmpoweRxSpecialtyDrugList?";
export const GET_EMPOWE_RX_SPECIALTY_DRUG_LIST_GROUP  = "/api/EmpoweRxSpecialtyDrugList/GetEmpoweRxSpecialtyDrugListGroup?userId=";
export const GET_PBM_LIST = "/api/EmpoweRxSpecialtyDrugList/GetPBMList";
export const SAVE_EMPOWERX_SPECIALTY_DRUG_LIST  = "/api/EmpoweRxSpecialtyDrugList/SaveEmpoweRxSpecialtyDrugList";
export const DELETE_EMPOWERRX_SPECIALTY_DRUG = "/api/EmpoweRxSpecialtyDrugList/DeleteEmpoweRxSpecialtyDrug?id="
export const EMPOWE_RX_RFP_CREATE = "/api/Empowerx_Rfp/Create"
export const EMPOWE_RX_RFP_UPDATE = "/api/Empowerx_Rfp/Update"
export const EMPOWE_RX_RFP_DELETE = "/api/Empowerx_Rfp/Delete?Id="
export const CREATE_BIDDER_INFO = "/api/Bidder_Info/Create"
export const UPDATE_BIDDER_INFO = "/api/Bidder_Info/Update"
export const DELETE_BIDDER_INFO = "/api/Bidder_Info/Delete/"
export const GETEMPOWERXDRUGDISCOUNTBYCLIENTID = "/api/EmpoweRxDrugDiscount/GetEmpoweRxDrugDiscountByClientId?clientId="

export const GETEMPOWERXRFP = "/api/Empowerx_Rfp/GetEmpowerxRfp/"

export const GETRFPSURVEYANSWERS = "/api/Rfp_Survey/GetRfpSurveyAnswers?"
export const RFPSURVEYCREATEUPDATE = "/api/Rfp_Survey/CreateUpdate"
export const DELETE_EMPOWER_RX_SPECIALTY_DRUG_LIST_GROUP = "/api/EmpoweRxSpecialtyDrugList/DeleteEmpoweRxSpecialtyDrugListGroup?"
export const GET_LIST_OF_CLINICAL_TEAM_MEMBER_DETAILS = "/api/ClinicalTeamMemberDetail/GetListOfClinicalTeamMemberDetails";
export const SAVE_CLINICAL_TEAM_MEMBER = "/api/ClinicalTeamMemberDetail/CreateClinicalTeamMember";
export const UPDATECLINICALTEAMMEMBER = "/api/ClinicalTeamMemberDetail/UpdateClinicalTeamMember";
export const COMPLETEORCANCELSBARREQUEST = "/api/ClinicalIntake/CompleteOrCancelSBARRequest?";
export const GETCLIENTBYCLIENTID = "/api/Clients/GetClientByClientID?clientID=";
export const DELETECLINICALTEAMMEMBER = "/api/ClinicalTeamMemberDetail/DeleteClinicalTeamMember?email=";
export const GETCLIENTBYCGTMEMBERID="/api/ClinicalIntake/GetClientByCGTMemberID?"
export const CLINICAL_SUPPORT_REQUEST="/api/Clinical_Support_Request/SubmitRequest"
export const SUBMITRFPSURVEY="/api/Rfp_Survey/SubmitRfpSurvey?"
export const SIGN_WITH_GOOGLE_URL = "/api/account/signin-google"
export const SIGNOUT_GOOGLE_URL = "/api/signout-Google-hub";
export const UPLOADFILESTOIMPORTRFPSURVEY= "/api/Rfp_Survey/UploadFilesToImportDataIntoSnowflake?"
export const CHECKRFPSURVEYDATAINSERTINTOSNOWFLAKE = "/api/Rfp_Survey/CheckRFPSurveyDatainsertintoSnowflake?"
export const GET_LIST_OF_Pharmacy_TEAM_MEMBER_DETAILS = "/api/PharmacyTeamMemberDetail/GetListOfPharmacyTeamMemberDetails";
export const SAVE_Pharmacy_TEAM_MEMBER = "/api/PharmacyTeamMemberDetail/CreatePharmacyTeamMember";
export const UPDATEPharmacyTEAMMEMBER = "/api/PharmacyTeamMemberDetail/UpdatePharmacyTeamMember";
export const DELETEPharmacyTEAMMEMBER = "/api/PharmacyTeamMemberDetail/DeletePharmacyTeamMember?email=";
export const GETALLRXBLOCKPRICING= "/api/RxBlockPricing/GetAllRxBlockPricing"
export const IMPORT_RX_BLOCK_PRICING= "/api/RxBlockPricing/ImportRxBlockPricing"
export const GETALLGPO= "/api/GPO/GetAllGPO"
export const GETAPPACCESSCONDITIONSBYSIZEORCOST= "/api/RxBlockPricing/GetAllAccessConditionsbysizeorcost"
export const GETALLPBM= "/api/RxBlockPricing/GetAllPBM"
export const GETALLCONTRACTPERIOD= "/api/RxBlockPricing/GetAllContractPeriod"
export const GETALLPBMBUYINGSTRUCTURE= "/api/RxBlockPricing/GetAllPBMBuyingStructure"
export const GETREBATESTRUCTURE= "/api/RxBlockPricing/GetAllRebateStructure"
export const GETALLPRESENTATIONONALIAS= "/api/RxBlockPricing/GetAllPresentationAlias"
export const GETFORMULARYTYPE= "/api/RxBlockPricing/GetAllFormularyType"
export const GETALLPRICINGSTRUCTURE= "/api/RxBlockPricing/GetAllPricingStructure"
export const GETSPECIALTYPHARMACYNETWORK= "/api/RxBlockPricing/GetAllSpecialtyPharmacyNetwork"
export const GETALLPLANSPONSORTYPE= "/api/RxBlockPricing/GetAllPlanSponsorType"
export const GETALLBENEFITBUYINGAPPROACH= "/api/RxBlockPricing/GetAllBenefitBuyingApproach"
export const GETALLREBATESAPPROACHHIV= "/api/RxBlockPricing/GetAllRebatesApproachHIV"
export const GETALLRETAILNETWORK3090= "/api/RxBlockPricing/GetAllRetailNetwork3090"
export const GETCURRENTPERIODDATA= "/api/RxBlockPricing/GetCurrentPeriodData"
export const CREATEUPDATEPERIODDATA= "/api/RxBlockPricing/CreateOrUpdateRxBlockPricingPeriodData"
export const CREATEORUPDATEGPO= "/api/GPO/CreateOrUpdateGPO"
export const GETGPOBYID= "/api/GPO/GetGPOById"
export const GETALLPRICINGSTRUCTUREBYGPOID= "/api/RxBlockPricing/GetAllPricingStructureByGPOId"
export const GETALLSPECIALTYPHARMACYNETWORKBYGPOID= "/api/RxBlockPricing/GetAllSpecialtyPharmacyNetworkByGPOId"
export const SEND_MARKET_SCAN_MANAGEMENT_FORM_FILL_UP_REQUEST =
"/api/RxBlockPricing/MarketScanManagementRequest?";
export const GET_MARKET_SCAN_MANAGEMENT_LIST =
"/api/RxBlockPricing/GetMarketScanManagementRequestList";
export const APPROVE_MARKET_SCAN_MANAGEMENT_REQUEST =
"/api/RxBlockPricing/ApproveMarketScanManagementRequest?";
export const GETHOLIDAYDATES = "/api/HolidayDate/GetHolidayDates?";
export const GETPRESIGNEDURL = '/api/Rfp_Survey/GetPresignedURL?';
export const GETPRESIGNEDURLOFSUPPORTINGFILE = '/api/Rfp_Survey/GetPresignedUrlofSupportingFile?';
export const GETCARRIERFILETYPE = '/api/MedicalCarrier/GetCarrierFileType';
export const IMPORTRXBLOCKPRICINGFORINTERNALUSER= "/api/RxBlockPricing/ImportRxBlockPricingForInternalUser"
export const DUPLICATE_QUESTIONNARIE='/api/Empowerx_Rfp/QuestionnaireDuplicate?'
export const DELETE_DUPLICATE_QUESTIONNARIE='/api/Empowerx_Rfp/DeleteDuplicateQuestionnaire?';
export const VENDOR_FROM_SALES_FORCE='/api/CedarGate/GetVendorFromSalesForce';
export const DECLINERFPSURVEY="/api/Rfp_Survey/DeclineRfpSurvey?";
export const ACCEPTRFPSURVEY="/api/Rfp_Survey/acceptRfpSurvey?";
export const GETVENDORPRICINGVALUE="/api/Rfp_Survey/GetVendorPriceValue?";
export const SAVERFPSUMMARY="/api/Rfp_Survey/AddRFPQuestionnaireDetails";
export const ADDUPDATERFPNEWQUESTIONS="/api/Empowerx_Rfp/AddUpdateQuestions";
export const DELETERFPNEWQUESTIONS="/api/Empowerx_Rfp/DeleteNewQuestions";
export const GETRFPNEWQUESTIONS="/api/Empowerx_Rfp/GetNewQuestions?RfpId=";
export const GETEMPOWERXDRUGDISCOUNTINRFP="/api/EmpoweRxDrugDiscount/GetEmpoweRxDrugDiscountInRfp?";
export const CHECKBIDFILERECORDBYCLIENTNAME="/api/Empowerx_Rfp/CheckBidFileRecordbyClientName?"
export const GETPRESIGNEDURLDRUDISCOUNTFILE='/api/EmpoweRxDrugDiscount/GetPresignedURLDrugDiscountFile?';
export const SEND_QR_EMAIL = "/api/login/send-qr-email"
